import postServices from './postServices'

// POST
const postCommand = (endpoint, data) => postServices(endpoint, data)

const API = {   
    postCommand
}

export default API;